import React, { useMemo, useState } from "react";
import { useI18n } from "../i18n";
import { Search } from "lucide-react";
import { GLOSSARY_TERMS, CATEGORIES } from "../data/glossaryTerms";

export default function Glossary() {
  const { t, lang } = useI18n();
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");

  const filtered = useMemo(() => {
    const Q = q.trim().toLowerCase();
    return GLOSSARY_TERMS.filter((e) => {
      if (cat !== "all" && e.cat !== cat) return false;
      if (!Q) return true;
      return (
        e.term.toLowerCase().includes(Q) ||
        (lang === "pt" ? e.pt : e.en).toLowerCase().includes(Q)
      );
    });
  }, [q, lang, cat]);

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 pt-28 pb-16" data-testid="page-glossary">
      <div>
        <span className="text-xs uppercase tracking-[0.2em] text-sky-400 font-mono">
          {lang === "pt" ? "Para quem decide sozinho" : "For the self-directed"}
        </span>
        <h1 className="mt-2 font-display text-4xl lg:text-5xl tracking-tight">{t.glossary.title}</h1>
        <p className="mt-3 text-neutral-400">
          {lang === "pt"
            ? `${GLOSSARY_TERMS.length} termos em ${CATEGORIES.length - 1} categorias. Sem jargão.`
            : `${GLOSSARY_TERMS.length} terms across ${CATEGORIES.length - 1} categories. No jargon.`}
        </p>
      </div>

      <div className="mt-6 relative max-w-md">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t.glossary.search}
          data-testid="glossary-search"
          className="w-full bg-white/5 border border-white/10 rounded-md pl-8 pr-3 py-2 text-sm focus:outline-none focus:border-gold-500"
        />
      </div>

      <div className="mt-6 flex flex-wrap gap-2" data-testid="glossary-cats">
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            onClick={() => setCat(c.id)}
            data-testid={`cat-${c.id}`}
            className={`px-3 py-1.5 rounded-md border text-xs font-mono uppercase tracking-[0.15em] transition-colors ${
              cat === c.id
                ? "bg-gold-500 border-gold-500 text-black"
                : "bg-white/5 border-white/10 text-neutral-400 hover:text-white"
            }`}
          >
            {lang === "pt" ? c.pt : c.en}
          </button>
        ))}
      </div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="glossary-grid">
        {filtered.map((e) => (
          <div key={e.term + e.cat} className="surface p-4" data-testid={`glossary-${e.term}`}>
            <div className="font-display text-lg text-white tracking-tight">{e.term}</div>
            <div className="mt-1.5 text-sm text-neutral-400 leading-relaxed">
              {lang === "pt" ? e.pt : e.en}
            </div>
          </div>
        ))}
      </div>
      {filtered.length === 0 && (
        <div className="mt-8 surface p-8 text-center text-neutral-500">
          {lang === "pt" ? "Nenhum termo encontrado." : "No terms found."}
        </div>
      )}
    </div>
  );
}
